import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { DragHandle } from '@mui/icons-material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import HelpIcon from '@mui/icons-material/Help';
import GuideIcon from '@mui/icons-material/Book';
import ReportIcon from '@mui/icons-material/Report';
import SupportIcon from '@mui/icons-material/ContactSupport';
import SettingsIcon from '@mui/icons-material/Settings';
import SearchBox from './SearchBox';
import { Box, styled, type Theme } from '@mui/material';

const drawerWidth = 240;
const miniDrawerWidth = 60;

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  borderBottom: `1px solid ${theme.palette.divider}`,
  boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
  zIndex: theme.zIndex.drawer + 1,
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 2),
  minHeight: '64px !important',
  gap: theme.spacing(2),
}));

const LeftSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  flex: '0 0 auto',
});

const CenterSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  justifyContent: 'center',
  maxWidth: '600px',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    maxWidth: '400px',
  },
}));

const RightSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flex: '0 0 auto',
});

const DragHandleButton = styled(IconButton)(({ theme }) => ({
  borderRadius: '8px',
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(0.75),
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.primary.main,
  },
  transition: theme.transitions.create(['background-color', 'border-color'], {
    duration: theme.transitions.duration.short,
  }),
}));

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.125rem',
  color: theme.palette.text.primary,
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

const MenuIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary,
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  gap: theme.spacing(1.5),
  padding: theme.spacing(1, 2),
  '& .MuiSvgIcon-root': {
    fontSize: '1.25rem',
  },
}));

class Header extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);

    this.state = {
      anchorEl: null,
      menuopen: false,
      useropen: false,
      useranchor: null,
      settingsopen: false,
      settingsanchor: null,
    };
  }

  handleClick = (menu:any,page:any,index:any)=> () => {
    console.log('handleclick:menu,page,index',menu,page,index);
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
    
  };

  onUserOpen = (event:any) => {
    this.setState({ useranchor: event.currentTarget, useropen:true });
  };

  onUserProfile = (event:any) => {
    this.setState({ useranchor: null, useropen:false });
    const page = 'profile';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onUserAccount = (event:any) => {
    this.setState({ useranchor: null, useropen:false });
    const page = 'profile';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onUserAnnouncement = (event:any) => {
    this.setState({ useranchor: null, useropen:false });
    const page = 'announcement';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onUserSignOut = (event:any) => {
    this.setState({ useranchor: null, useropen:false });
    const page = 'logout';
    this.props.handleSetContent(null,page).then( 
      () => {
      this.props.closeDrawer();
    },
    (reason:any) => {
      console.error(reason); // Error!
    }
  );
  };

  onUserClose = () => {
    this.setState({ useranchor: null, useropen:false });
  };

  onSettingsOpen = (event:any) => {
    this.setState({ settingsanchor: event.currentTarget, settingsopen:true });
  };

  onHelp = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'help';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onGuide = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'help';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onSupport = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'support';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onAbout = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'about';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onSettingsClose = () => {
    this.setState({ settingsanchor: null, settingsopen:false });
  };

  onKeyPress = (event:any) => {
    if(event.key === 'Enter') this.onSearch(event.target.value);
  }

  onSearch = (query:any) => {
    const {page} = this.props;
    
    //const page = 'search';
    this.props.handleSetContent(query,page,true).then( () => {
      //clear search? no.
    });
  };

  onMenu = (event:any) => {
    this.setState({ anchorEl: event.currentTarget, menuopen:true });
    const page = 'kanban';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onMaintenance = (event:any) => {
    this.setState({ anchorEl: event.currentTarget, menuopen:true });
    const page = 'maintenance';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onClose = () => {
    this.setState({ anchorEl: null, menuopen:false });
  };

  render() {
    const {page, navDrawerOpen, toggleDrawer, data, onSearched} = this.props;
    const { useropen, useranchor, settingsopen, settingsanchor } = this.state;
    const eti = (data.bd||{}).eti;
    const isMain = (eti===1);

    return (
      <Box sx={{ flexGrow: 1 }}>
        <StyledAppBar
          position="absolute"
          sx={{
            width: navDrawerOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
            transition: (theme) => theme.transitions.create(['width', 'margin'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
            ...(navDrawerOpen && {
              marginLeft: drawerWidth,
            }),
          }}
        >
          <StyledToolbar>
            {/* Left Section: DragHandle and Title */}
            <LeftSection>
              <DragHandleButton
                onClick={toggleDrawer}
                aria-label="toggle drawer"
                size="medium"
              >
                <DragHandle />
              </DragHandleButton>
              <Title variant="h6" noWrap>
                {data.bd?.enm || ''}
              </Title>
            </LeftSection>

            {/* Center Section: Search Box */}
            <CenterSection>
              <SearchBox 
                page={page} 
                onKeyPress={this.onKeyPress} 
                onSearched={onSearched}
                sx={{ width: '100%' }}
              />
            </CenterSection>

            {/* Right Section: Settings and User Menu */}
            <RightSection>
              {/* Settings Menu */}
              <MenuIconButton
                aria-owns={settingsopen ? 'help-menu' : undefined}
                aria-haspopup="true"
                onClick={this.onSettingsOpen}
                size="medium"
              >
                <SettingsIcon />
              </MenuIconButton>
              <Menu
                id="help-menu"
                anchorEl={settingsanchor}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
                open={settingsopen}
                onClose={this.onSettingsClose}
                PaperProps={{
                  sx: {
                    mt: 1,
                    minWidth: 200,
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                  }
                }}
              >
                <StyledMenuItem onClick={this.onHelp}>
                  <HelpIcon />
                  Help
                </StyledMenuItem>
                <StyledMenuItem onClick={this.onGuide}>
                  <GuideIcon />
                  User Guide
                </StyledMenuItem>
                <StyledMenuItem onClick={this.onSupport}>
                  <SupportIcon />
                  Support
                </StyledMenuItem>
                {isMain && (
                  <StyledMenuItem onClick={this.onClose}>
                    <ReportIcon />
                    Reports
                  </StyledMenuItem>
                )}
              </Menu>

              {/* User Menu */}
              <MenuIconButton
                aria-owns={useropen ? 'menu-user' : undefined}
                aria-haspopup="true"
                onClick={this.onUserOpen}
                size="medium"
              >
                <AccountCircle />
              </MenuIconButton>
              <Menu
                id="menu-user"
                anchorEl={useranchor}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
                open={useropen}
                onClose={this.onUserClose}
                PaperProps={{
                  sx: {
                    mt: 1,
                    minWidth: 200,
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                  }
                }}
              >
                <StyledMenuItem onClick={this.onUserAccount}>
                  <AccountCircle />
                  My Account
                </StyledMenuItem>
                {/* <StyledMenuItem onClick={this.onUserAnnouncement}>
                  <GuideIcon />
                  Announcement
                </StyledMenuItem> */}
                <StyledMenuItem 
                  onClick={this.onUserSignOut}
                  sx={{ 
                    color: 'error.main',
                    '&:hover': {
                      backgroundColor: 'error.light',
                      color: 'error.dark',
                    }
                  }}
                >
                  <AccountCircle />
                  Logout
                </StyledMenuItem>
              </Menu>
            </RightSection>
          </StyledToolbar>
        </StyledAppBar>
      </Box>
    );
  }
}

Header.propTypes = {
  hstyles: PropTypes.object,
  toggleDrawer: PropTypes.func
};

//export default Header;
export default Header;
